module.exports = __webpack_public_path__ + "img/pokeball.6058de96.svg";